import { DoodApiError } from '@shared/interfaces/error.interface';
import { CrossSellingProposals } from './cross-selling.model';

export interface CrossSellingData {
  triggerProductId: string;
  crossSellingRule: CrossSellingProposals;
}

export interface CrossSellingState {
  data: CrossSellingData | null;
  isLoaded: boolean;
  isLoading: boolean;
  hasError: boolean;
  error: DoodApiError | null;
}

export const CROSS_SELLING_STORE_KEY = 'CrossSelling';

export const CROSS_SELLING_STORE_INITIAL_STATE: CrossSellingState = {
  data: null,
  isLoaded: false,
  isLoading: false,
  hasError: false,
  error: null,
};
